'use strict';

require('../../style/index.less');

require('./index.less');

require('../../input/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/select/style/index.js
 ** module id = 28
 ** module chunks = 0
 **/